<template>
  <bs-modal id="user-list" show-header dialog-centered>
    <template slot="modal-title">
      <h5 class="modal-title" id="exampleModalLabel">ユーザ名リスト編集</h5>
    </template>

    <table class="table table-bordered bg-white tbl_request01">
      <tbody>
        <tr>
          <th class="bg-tbl-light">ユーザ名</th>
          <td>
            <input
              type="text"
              class="form-control"
              :class="{
                'is-invalid':
                  errorResponse.ngfg_endUserNa || errorResponse.ngfg_deliveryCd
              }"
              v-model="input_enduser_na"
            />
            <div class="invalid-feedback" v-if="errorResponse.ngfg_endUserNa">
              {{ errorResponse.msg_endUserNa }}
            </div>
            <div class="invalid-feedback" v-if="errorResponse.ngfg_deliveryCd">
              {{ errorResponse.msg_deliveryCd }}
            </div>
          </td>
          <!-- 20200521 ユーザリストはユーザ名のみ表示のため削除
          <th class="bg-tbl-light">ユーザ名(カナ)</th>
          <td>
            <input
              type="text"
              class="form-control"
              :class="{ 'is-invalid': errorResponse.ngfg_endUserKanaNa }"
              v-model="input_enduserkana_na"
            />
            <div
              class="invalid-feedback"
              v-if="errorResponse.ngfg_endUserKanaNa"
            >
              {{ errorResponse.msg_endUserKanaNa }}
            </div>
          </td>
          -->
        </tr>
      </tbody>
    </table>

    <div class="btn-add">
      <input
        type="submit"
        class="btn btn-primary"
        value="登録"
        @click="editEndUserListHandler"
      />
    </div>
    <div class="table-fix">
      <div
        class="table-fix__head-wrap"
        :style="{ paddingRight: `${getScrollbarWidth()}px` }"
      >
        <table
          class="table table-bordered bg-white tbl_refer04 table-fix__head"
          :style="{
            transform: `translateX(-${scroll_left}px)`
          }"
        >
          <colgroup>
            <col width="448" />
            <col width="222" />
            <!--
              <col width="222" />
            -->
          </colgroup>
          <thead class="bg-tbl-head text-white">
            <tr>
              <th>ユーザ名</th>
              <!--
              <th>ユーザ名(カナ)</th>
              -->
              <th></th>
            </tr>
          </thead>
        </table>
      </div>
      <div class="table-fix__body-wrap" ref="tableBody">
        <table
          class="table table-bordered bg-white tbl_refer04 table-fix__body mb0"
        >
          <colgroup>
            <col width="448" />
            <col width="222" />
          </colgroup>
          <tbody>
            <row
              v-for="user in userList"
              :key="user.row_no"
              :user="user"
              @refreshList="refreshEndUserList"
            ></row>
          </tbody>
        </table>
      </div>
    </div>
  </bs-modal>
</template>

<script>
// Component
import Row from "./UserRow.vue";

import { store as UserStore } from "../../store/UserList";

export default {
  components: {
    Row
  },

  data() {
    return {
      userList: [],

      // Edit End User
      input_enduser_na: "",
      //input_enduserkana_na: "",
      errorResponse: [],

      // Scroll
      scroll_left: 0
    };
  },
  mounted() {
    this.scrollHandler();
  },
  methods: {
    scrollHandler() {
      if (this.$refs.tableBody) {
        this.scroll_left = this.$refs.tableBody.scrollLeft;
      }

      requestAnimationFrame(this.scrollHandler.bind(this));
    },
    async getEndUserList() {
      this.userList = [];
      this.input_enduser_na = "";
      //this.input_enduserkana_na = "";
      this.errorResponse = [];

      const response = await this.getEndUserListHandler();
      if (response.responseData.return != "0") {
        this.redirectToLogin();
        return;
      }

      this.userList = this.getAsteriaArray(response.responseData, "userList");
    },
    /**
     * Get initial data from ASTERIA
     */
    async getEndUserListHandler() {
      const response = await this.postAsteria("CommonAPI", "getEndUserList", {
        delivery_cd: UserStore.deliveryCd
      });

      return response;
    },
    /**
     * Input EndUser
     */
    async editEndUserListHandler() {
      this.errorResponse = [];

      const response = await this.postAsteria("CommonAPI", "editEndUserList", {
        delivery_cd: UserStore.deliveryCd,
        enduser_na: this.input_enduser_na,
        enduserkana_na: ""
      });

      if (response.responseData.return == 0) {
        UserStore.userList = this.getAsteriaArray(
          response.responseData,
          "userList"
        );
        this.refreshEndUserList();
        return;
      } else if (response.responseData.return == 1) {
        this.errorResponse = response.responseData;
        return;
      }
    },

    async refreshEndUserList() {
      this.userList = [];
      this.input_enduser_na = "";
      //this.input_enduserkana_na = "";
      this.errorResponse = [];

      this.userList = UserStore.userList;
    },

    getScrollbarWidth() {
      return this.$utility.getScrollbarWidth();
    }
  }
};
</script>
